import { Box } from "@mui/material";

export const TabPanel: React.FC<{ value: number, index: number, children: React.ReactNode }> = ({ value, index, children }) => {
    return (
      <div role="tabpanel" hidden={value !== index}>
        {value === index && (
          <Box p={3}>
            {children}
          </Box>
        )}
      </div>
    );
  };